import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AuthLoadingSkeleton } from '@/components/ui/auth-loading-skeleton';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading && requireAuth) {
    return <AuthLoadingSkeleton />;
  }

  if (!user && requireAuth) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (user && !requireAuth) {
    return <Navigate to="/practice" replace />;
  }

  return <>{children}</>;
};
